import { render, staticRenderFns } from "./companyExpand.vue?vue&type=template&id=994adc90&scoped=true&"
import script from "./companyExpand.vue?vue&type=script&lang=js&"
export * from "./companyExpand.vue?vue&type=script&lang=js&"
import style0 from "./companyExpand.vue?vue&type=style&index=0&id=994adc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994adc90",
  null
  
)

export default component.exports